@if (graphLoaded) {
<div
	id="chart"
>
	<apx-chart
		#chart
		[series]="chartOptions.series"
		[chart]="chartOptions.chart"
		[stroke]="chartOptions.stroke"
		[xaxis]="chartOptions.xaxis"
		[grid]="chartOptions.grid"
		[title]="chartOptions.title"></apx-chart>
</div>
}
